import { yandexMetrika } from '@/helpers/yandexMetrika'
import { MobileApps } from '@/store/slices/stagesSlice/interfaces'
import { useEffect, useState } from 'react'
import { OperatingSystem } from '@/components/pages/AreaPageModern/components/AreaPageMobileApps/types'
import cn from 'classnames'
import styles from './AreaPageMobileApps.module.scss'
import { storeLinks } from '@/constants'

export const AreaPageMobileApps = ({ mobileApps }: { mobileApps: MobileApps | null }) => {
  const [operatingSystem, setOperatingSystem] = useState<OperatingSystem | null>(null)
  const isAndroid = operatingSystem === OperatingSystem.Android
  const isIOS = operatingSystem === OperatingSystem.IOS
  const isOtherOperatingSystem = operatingSystem === OperatingSystem.Other

  const getStoreLink = (operatingSystem: OperatingSystem) => {
    if (operatingSystem === OperatingSystem.IOS) {
      return mobileApps ? mobileApps.ios_link : storeLinks.appStore
    } else if (operatingSystem === OperatingSystem.Android) {
      return mobileApps ? mobileApps.android_link : storeLinks.appStore
    }
    return ''
  }

  const appMetrika = {
    [OperatingSystem.IOS]: yandexMetrika.reachGoalButtonClickAppStoreNew,
    [OperatingSystem.Android]: yandexMetrika.reachGoalButtonClickGooglePlayNew,
  }

  useEffect(() => {
    const userAgent = navigator.userAgent
    if (/android/i.test(userAgent)) {
      setOperatingSystem(OperatingSystem.Android)
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      setOperatingSystem(OperatingSystem.IOS)
    } else {
      setOperatingSystem(OperatingSystem.Other)
    }
  }, [])

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>
        Скачайте приложение
        <br />
        и&nbsp;оплачивайте парковку в&nbsp;один клик
      </h2>
      <div className={styles.buttons}>
        {(isIOS || isAndroid) && (
          <a
            href={getStoreLink(operatingSystem)}
            className={styles.link}
            onClick={appMetrika[operatingSystem]}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className={styles.commonButton}>Скачать приложение</button>
          </a>
        )}
        {isOtherOperatingSystem && (
          <>
            <StoreButton
              link={getStoreLink(OperatingSystem.IOS)}
              handleClick={yandexMetrika.reachGoalButtonClickAppStoreNew}
              imgSrc="/images/app-store-app-ru.png"
              imgAlt="App Store"
            />
            <StoreButton
              link={getStoreLink(OperatingSystem.Android)}
              handleClick={yandexMetrika.reachGoalButtonClickGooglePlayNew}
              imgSrc="/images/google-play-app-ru.png"
              imgAlt="Google Play"
            />
          </>
        )}
      </div>
    </section>
  )
}

const StoreButton = ({
  link,
  handleClick,
  imgSrc,
  imgAlt,
}: {
  link: string
  handleClick: () => void
  imgSrc: string
  imgAlt: string
}) => {
  return (
    <a
      href={link}
      className={cn(styles.link, styles.storeButton)}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={imgSrc} alt={imgAlt} className={styles.storeButton__image} />
    </a>
  )
}
